module.exports = __webpack_public_path__ + "img/logo.3c464e79.png";